import { Check, Loader2, RotateCcw, Save, Sparkles, Upload } from "lucide-react";
import { format } from "date-fns";
import { useDirtyGuard } from "@/components/admin/DirtyGuard";
import { cn } from "@/lib/utils";

/**
 * Floating save pill for the story editor: live status (AI writing / autosaving / unsaved / all saved), discard,
 * save draft and a sol «Publiser». Drafts autosave – the pill says so.
 */
export const EditorSaveBar = ({ dirty, saving, autosaving, aiBusy, lastSaved, published, isNew, onSave, onPublish, onCancel, canSave }) => {
  useDirtyGuard(dirty, "post-editor");
  const status = aiBusy ? { dot: "is-ai", text: "AI skriv …" } : saving || autosaving ? { dot: "is-busy", text: autosaving ? "Lagrar automatisk …" : "Lagrar …" }
    : isNew ? { dot: "is-dirty", text: dirty ? "Ikkje lagra enno" : "Ny sak – ikkje lagra enno" }
    : dirty ? { dot: "is-dirty", text: "Ulagra endringar" } : { dot: "is-clean", text: lastSaved ? `Alt lagra · ${format(lastSaved, "HH:mm")}` : "Alt lagra" };
  return (
    <div className="editor-savebar" role="region" aria-label="Lagring" data-testid="admin-save-bar">
      <div className="flex min-w-0 items-center gap-2 text-[13px]" aria-live="polite">
        <span className={cn("savebar-dot", status.dot)} aria-hidden="true">{status.dot === "is-ai" && <Sparkles className="h-3 w-3" />}{status.dot === "is-clean" && <Check className="h-3 w-3" />}</span>
        <span className="truncate" data-testid={dirty ? "form-dirty-indicator" : "form-clean-indicator"}>{status.text}</span>
        {!published && !isNew && <span className="hidden text-paper/50 sm:inline" data-testid="autosave-hint">· utkast lagrast av seg sjølv</span>}
      </div>
      <div className="flex shrink-0 items-center gap-1.5">
        {dirty && !isNew && <button type="button" onClick={onCancel} disabled={saving} className="savebar-ghost" data-testid="form-cancel-button"><RotateCcw className="h-3.5 w-3.5" /> <span className="hidden sm:inline">Forkast</span></button>}
        <button type="button" onClick={onSave} disabled={!canSave || saving} className="savebar-btn" data-testid="form-save-button">
          {saving && !autosaving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} {published ? "Lagre" : "Lagre utkast"}
        </button>
        {!published && <button type="button" onClick={onPublish} disabled={!canSave || saving} className="savebar-btn is-sol" data-testid="post-publish-btn"><Upload className="h-4 w-4" /> Publiser</button>}
      </div>
    </div>
  );
};
